import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { StateMasterProvider } from "../contexts/StateMasterContext";
import { DistrictProvider } from "../contexts/DistrictContext";
import { CountryProvider } from "../contexts/CountryContext";
import { TalukProvider } from "../contexts/TalukContext";
import { CityProvider } from "../contexts/CityContext";
import { VillageProvider } from "../contexts/VillageContext";
import { PincodeProvider } from "../contexts/PincodeContext";
import { AuthProvider } from "../contexts/JWTContext";
import { DialogProvider } from "../contexts/DialogContext";

export const VillageComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <VillageProvider key={0} />,
        <CityProvider key={1} />,
        <TalukProvider key={2} />,
        <DistrictProvider key={3} />,
        <CountryProvider key={4} />,
        <StateMasterProvider key={5} />,
        <PincodeProvider key={6} />,
        <DialogProvider key={7} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
